import {useAppContext} from '../../app/AppContext';

const titlesMap = {
    '/planning-tool': 'Planning',
    '/track-and-trace': 'Track & Trace',
    '/orders': 'Orders',
    '/reports': 'Reports',
    '/settings': 'Settings'
};

export const useEvoIntegration = () => {
    return {
        startLoading: () => {
            window.parent.postMessage(
                JSON.stringify({type: 'ShowLoading'}),
                useAppContext().uiSettings?.evoPlatformUrl
            );
        },
        stopLoading: () => {
            window.parent.postMessage(
                JSON.stringify({type: 'HideLoading'}),
                useAppContext().uiSettings?.evoPlatformUrl
            );
        },
        reportLocation: (path: string) => {
            const featureName = titlesMap[Object.keys(titlesMap).find((key) => path.startsWith(key))] ?? 'Maxoptra';
            window.parent.postMessage(
                JSON.stringify({
                    type: 'ReportLocation',
                    url: location.href,
                    title: {featureName}
                }),
                useAppContext().uiSettings?.evoPlatformUrl
            );
        }
    };
};
